import { forwardRef, createElement } from 'react';

function IconTime(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M16.5 16c2.434 0 3.88 1.316 4.34 3.95A1.75 1.75 0 0119.116 22h-5.232a1.75 1.75 0 01-1.724-2.05c.46-2.634 1.906-3.95 4.34-3.95zM12 2c5.523 0 10 4.477 10 10a9.96 9.96 0 01-1.005 4.374 5.097 5.097 0 00-1.182-1.017A8.488 8.488 0 0020.5 12a8.5 8.5 0 10-9.996 8.369c.02.578.196 1.118.487 1.58C5.942 21.444 2 17.183 2 12 2 6.477 6.477 2 12 2zm4.5 8.5c1.105 0 2 1.12 2 2.5s-.895 2.5-2 2.5-2-1.12-2-2.5.895-2.5 2-2.5zM12 5.25a.75.75 0 01.743.648L12.75 6v6a.75.75 0 01-.648.743L12 12.75H7.5a.75.75 0 01-.102-1.493l.102-.007h3.75V6a.75.75 0 01.75-.75z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Time = /*#__PURE__*/forwardRef(IconTime);

export default Time;
//# sourceMappingURL=Time.js.map
